module.exports = __webpack_public_path__ + "static/media/souls.64c7b07f.jpg";